var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElableGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3232 7.7269C18.6121 8.02374 18.6056 8.49857 18.3088 8.78747L10.6028 16.2875C10.3116 16.5708 9.84774 16.5708 9.55657 16.2875L5.4769 12.3169C5.18007 12.028 5.17364 11.5532 5.46253 11.2563C5.75143 10.9595 6.22626 10.953 6.5231 11.2419L10.0797 14.7034L17.2626 7.71253C17.5594 7.42364 18.0343 7.43007 18.3232 7.7269Z",
    fill: "#0BAA4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElableGreenTick);
export default __webpack_public_path__ + "static/media/elable-green-tick.4e2536661fb3926aaacf73b14ee69a06.svg";
export { ForwardRef as ReactComponent };